import birdImage from 'assets/images/eventBoatRacingT10/bird.png'
import boatImage from 'assets/images/eventBoatRacingT10/boat.png'
import icoBac from 'assets/images/eventBoatRacingT10/icoBac.png'
import {
	getEventBoatRacing102025Boat
} from 'dataLayer/game'
import { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import BoatRacingDetailT10 from './components/BoatRacingDetailT10'
import BoatRacingHomeT10 from './components/BoatRacingHomeT10'
import BoatRacingRankT10 from './components/BoatRacingRankT10'
import ButtonBack from './components/ButtonBack'
import useTabHistory from './components/useTabHistory'

function EventBoatRacingT10() {
	const { t } = useTranslation()
	const location = useLocation()
	const navigate = useNavigate()
	const { currentTab: tabActive, push: setTabActive, back, forward } = useTabHistory(location?.state || 'EVENT');

	useEffect(() => {
		if (location?.state) {
			setTabActive(location.state);
		}
	}, [location?.state]);

	const handleNextPage = () => {
		if (tabActive === "EVENT") {
			navigate("/");
		} else if (tabActive === "DETAIL" || tabActive === "RANK") {
			back();
		}
	};

	const onPressTab = (tab) => {
		setTabActive(tab);
	};

	const { data: boatRacing102025, refetch: fetchEventBoatRacing102025Boat } = useQuery(
		getEventBoatRacing102025Boat(),
	)

	useEffect(() => {
		fetchEventBoatRacing102025Boat()
	}, [])

	const responsiveFontSizeBoat = (value) => {
		switch (true) {
			case value < 10:
				return 'boat-number-xs';
			case value < 100:
				return 'boat-number-sm';
			case value < 1000:
				return 'boat-number-md';
			case value < 10000:
				return 'boat-number-lg';
			case value < 100000:
				return 'boat-number-xl';
			case value < 1000000:
				return 'boat-number-2xl';
			case value < 10000000:
				return 'boat-number-3xl';
			default:
				return '';
		}
	}

	return (
		<div className="container-boat-racing-t10">
			<div className="container-water-wrapper-t10">
				<ButtonBack handleNextPage={handleNextPage} />
				<div className='boat-data'>
					<div className='boat-data-image'>
						<span className={`boat-number ${responsiveFontSizeBoat(boatRacing102025?.boat)}`}>X {boatRacing102025?.boat}</span>
						<img src={icoBac} alt="icoBac" className='image-background-boat' />
					</div>
				</div>
				<img src={boatImage} alt="icoBac" className='image-background-user-boat' />
				<img src={birdImage} alt="icoBac" className='image-background-bird' />
				<Row justify="center" className="m-0">
					<Col sx={24} className="p-0">
						<div
							className={`container-water-content-t10 container-boat-racing-content-t10 ${tabActive.toLowerCase()}`}
						>
							<div className="box-tab">
								<span
									onClick={() => onPressTab('EVENT')}
									className={`box-tab-item unselected ${tabActive == 'EVENT' ? 'active' : ''
										}`}
								>
									{t('event.event_boa_racing_t10.tab.name_event')}
								</span>
								<span
									onClick={() => onPressTab('DETAIL')}
									className={`box-tab-item unselected ${tabActive == 'DETAIL' ? 'active' : ''
										}`}
								>
									{t('event.event_boa_racing_t10.tab.detail')}
								</span>
								<span
									onClick={() => onPressTab('RANK')}
									className={`box-tab-item unselected ${tabActive == 'RANK' ? 'active' : ''
										}`}
								>
									{t('event.event_boa_racing_t10.tab.rank')}
								</span>
							</div>
							<div className="box-tab-content">
								{tabActive == 'EVENT' &&
									<BoatRacingHomeT10 />
								}
								{tabActive == 'DETAIL' && (
									<BoatRacingDetailT10 />
								)}
								{tabActive == 'RANK' && (
									<BoatRacingRankT10 />
								)}
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default EventBoatRacingT10
